import React from 'react';
import { useSelector } from 'react-redux';
import one from '../../assest/Team-Logo.png';

const JobInfo = () => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    en: {
      teamLead: "Team Lead Designer",
      company: "Leffler and Sons",
      personalInfo: "Personal Information",
      formInstruction: "Fill out this form, and we will answer you as soon as possible!",
      firstName: "Full Name*",
      email: "Email*",
      yourSkills: "Your Skills",
      phoneNumber: "Phone Number*",
      experience: "Experience",
      gender: "Gender*",
      currentLocation: "Current Location*",
      cvResume: "CV Or Resume*",
      photo: "Photo*",
      browse: "Browse",
      coverLetter: "Cover Letter",
      submit: "Submit",
      placeholder: {
        firstName: "Full Name",
        email: "Email",
        skills: "Skills",
        phone: "+92 345578545",
        experience: "Experience",
        gender: "Gender",
        location: "Write location",
        coverLetter: "Cover Letter.."
      }
    },
    sa: {
      teamLead: "قائد فريق المصممين",
      company: "ليفلر وأولاده",
      personalInfo: "معلومات شخصية",
      formInstruction: "املأ هذا النموذج ، وسنجيب عليك في أقرب وقت ممكن!",
      firstName: "الاسم الأول*",
      email: "البريد الإلكتروني*",
      yourSkills: "مهاراتك",
      phoneNumber: "رقم الهاتف*",
      experience: "خبرة",
      gender: "جنس*",
      currentLocation: "الموقع الحالي*",
      cvResume: "السيرة الذاتية أو السيرة الذاتية*",
      photo: "صورة*",
      browse: "تصفح",
      coverLetter: "خطاب تغطية",
      submit: "يقدم",
      placeholder: {
        firstName: "الاسم الأول",
        email: "البريد الإلكتروني",
        skills: "مهارات",
        phone: "+92 345578545",
        experience: "خبرة",
        gender: "جنس",
        location: "اكتب الموقع",
        coverLetter: "خطاب تغطية.."
      }
    },
    fr: {
      teamLead: "Chef d'équipe designer",
      company: "Leffler et fils",
      personalInfo: "Informations personnelles",
      formInstruction: "Remplissez ce formulaire et nous vous répondrons dès que possible!",
      firstName: "Prénom*",
      email: "Email*",
      yourSkills: "Vos compétences",
      phoneNumber: "Numéro de téléphone*",
      experience: "Expérience",
      gender: "Genre*",
      currentLocation: "Localisation actuelle*",
      cvResume: "CV ou curriculum vitae*",
      photo: "Photo*",
      browse: "Parcourir",
      coverLetter: "Lettre de motivation",
      submit: "Soumettre",
      placeholder: {
        firstName: "Prénom",
        email: "Email",
        skills: "Compétences",
        phone: "+92 345578545",
        experience: "Expérience",
        gender: "Genre",
        location: "Écrire l'emplacement",
        coverLetter: "Lettre de motivation.."
      }
    },
    de: {
      teamLead: "Teamleiter Designer",
      company: "Leffler und Söhne",
      personalInfo: "Persönliche Informationen",
      formInstruction: "Füllen Sie dieses Formular aus und wir werden Ihnen so schnell wie möglich antworten!",
      firstName: "Vorname*",
      email: "Email*",
      yourSkills: "Ihre Fähigkeiten",
      phoneNumber: "Telefonnummer*",
      experience: "Erfahrung",
      gender: "Geschlecht*",
      currentLocation: "Aktueller Standort*",
      cvResume: "Lebenslauf*",
      photo: "Foto*",
      browse: "Durchsuche",
      coverLetter: "Anschreiben",
      submit: "Einreichen",
      placeholder: {
        firstName: "Vorname",
        email: "Email",
        skills: "Fähigkeiten",
        phone: "+92 345578545",
        experience: "Erfahrung",
        gender: "Geschlecht",
        location: "Standort schreiben",
        coverLetter: "Anschreiben.."
      }
    }
  };

  const t = translations[language] || translations.en;

  return (
    <>
      <section className="mt-4">
        <div className="container">
          <div className="row justify-content-start">
            <div className="col-lg-8">
              <div className="d-flex align-items-start">
                <img src={one} alt="Team Logo" className="img-fluid me-3" style={{ maxWidth: '150px' }} />
                <div>
                  <h3 className="fw-bold">{t.teamLead}</h3>
                  <p className="text-muted">{t.company}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-4">
          <div className="p-4 rounded border shadow-sm bg-white">
            <h4 className="fw-bold">{t.personalInfo}</h4>
            <p>{t.formInstruction}</p>

            <form>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">{t.firstName}</label>
                  <input type="text" className="form-control" placeholder={t.placeholder.firstName} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t.email}</label>
                  <input type="email" className="form-control" placeholder={t.placeholder.email} />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">{t.yourSkills}</label>
                  <input type="text" className="form-control" placeholder={t.placeholder.skills} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t.phoneNumber}</label>
                  <input type="tel" className="form-control" placeholder={t.placeholder.phone} />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">{t.experience}</label>
                  <input type="text" className="form-control" placeholder={t.placeholder.experience} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t.gender}</label>
                  <input type="text" className="form-control" placeholder={t.placeholder.gender} />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">{t.currentLocation}</label>
                <textarea
                  className="form-control"
                  placeholder={t.placeholder.location}
                  rows="2"
                ></textarea>
              </div>

              <div className="row mb-3 mt-3">
                <div className="col-md-6">
                  <label className="form-label">{t.cvResume}</label>
                  <div className="input-group">
                    <input type="file" className="form-control" />
                    <button className="btn btn-danger" type="button">{t.browse}</button>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="form-label">{t.photo}</label>
                  <div className="input-group">
                    <input type="file" className="form-control" />
                    <button className="btn btn-danger" type="button">{t.browse}</button>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">{t.coverLetter}</label>
                <textarea className="form-control" placeholder={t.placeholder.coverLetter} rows="4"></textarea>
              </div>

              <button type="submit" className="btn btn-danger d-flex align-items-center">
                {t.submit} <i className="bi bi-arrow-right ms-2"></i>
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default JobInfo;
